import { SearchFormInputs } from "src/Modules/Hotels/constants";
import { explode } from "src/utility/objects";
import { formatDate } from "src/utility";

const perpareSeachObjectChipValues = (searchObject: SearchFormInputs) => {
  const { rooms, checkin, checkout, location } = explode(searchObject, {});
  const locationLabel = location?.label || "";
  const checkinDate = checkin ? formatDate(checkin, "MMM DD, YYYY") : "";
  const checkoutDate = checkout ? formatDate(checkout, "MMM DD, YYYY") : "";
  const totalPassengers = rooms.reduce((sum, room) => sum + (room.adults || 0) + (room.children || 0), 0);
  return {
    locationLabel,
    checkinDate,
    checkoutDate,
    totalPassengers,
  };
};

export { perpareSeachObjectChipValues };
